import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
import Breadcrumb from './modules/Breadcrumb'
export default new Vuex.Store({
  modules: {
    Breadcrumb
  }
})
